import React from 'react';
import cx from 'classnames';
import { StaticQuery, graphql } from 'gatsby';
import { MDXRenderer } from 'gatsby-plugin-mdx';
import styles from './Header.module.css';
import logo from './logo.png';

const setPreferredLanguage = (lang) => () => {
  // eslint-disable-next-line no-undef
  localStorage.setItem('gim_preferred_lang', lang);
  // eslint-disable-next-line no-undef, no-restricted-globals
  location.reload();
};

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
    };
  }

  render() {
    const { locale } = this.props;
    const { menuOpen } = this.state;
    return (
      <StaticQuery
        query={graphql`
      {
        components: allFile(filter: {
          sourceInstanceName: {eq: "components"}, 
          childMdx: {frontmatter: {component: {eq: "header"}}}
        }) {
          edges {
            node {
              childMdx {
                body
                fields {
                  locale
                }
              }
            }
          }
        }
      }
    `}
        render={({ components }) => {
          const links = components.edges.find(
            (d) => d.node.childMdx.fields.locale === locale,
          ).node.childMdx.body;

          return (
            <nav className={styles.nav}>
              <div className={styles.inner}>
                <a href={`/${locale}`}>
                  <img className={styles.logo} src={logo} alt="logo" />
                </a>

                <div className={styles.buttonGroup}>
                  <button
                    type="button"
                    onClick={setPreferredLanguage(locale === 'en' ? 'zh' : 'en')}
                  >
                    {locale === 'en' ? '中文' : 'English'}
                  </button>

                  <button
                    type="button"
                    className={cx(styles.hamburgerMenu, menuOpen && styles.menuOpen)}
                    onClick={() => { this.setState({ menuOpen: !menuOpen }); }}
                  >
                    <div className={styles.bar} />
                    <div className={styles.bar} />
                    <div className={styles.bar} />
                  </button>
                </div>

                <div className={cx(styles.links, menuOpen && styles.menuOpen)}>
                  <MDXRenderer>{links}</MDXRenderer>
                  <button
                    type="button"
                    onClick={setPreferredLanguage(locale === 'en' ? 'zh' : 'en')}
                  >
                    {locale === 'en' ? '中文' : 'English'}
                  </button>
                </div>
              </div>
            </nav>
          );
        }}
      />
    );
  }
}

export default Header;
